define('app/views/templates/helpers/forHbs',['Handlebars'], function (Handlebars) {
  function forHbs(from, to, increment, block) {
    var accumulator = '';
    for (var i = from; i <= parseInt(to); i += increment) {
      accumulator += block.fn(i);
    }
    return accumulator;
  }
  Handlebars.registerHelper('forHbs', forHbs);
  return forHbs;
});

